import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'accent' | 'ghost' | 'danger';

/**
 * `.btn-*` was pasted into a hundred and seventy-two places, and the one
 * variant nobody had a class for — destructive — was hand-mixed at the call
 * site as `btn-primary !bg-danger hover:!bg-danger/80`. It exists here now,
 * spelled once.
 *
 * `buttonClass` is the same thing for the links that look like buttons:
 * react-router's <Link> cannot be a <button>, and wrapping one in the other
 * is worse than sharing the string.
 */
export function buttonClass(variant: ButtonVariant = 'primary', className = ''): string {
  const base =
    variant === 'danger' ? 'btn-primary !bg-danger hover:!bg-danger/80' : `btn-${variant}`;
  return className ? `${base} ${className}` : base;
}

export function Button({
  variant = 'primary',
  className = '',
  children,
  ...rest
}: {
  variant?: ButtonVariant;
  children: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button type="button" {...rest} className={buttonClass(variant, className)}>
      {children}
    </button>
  );
}
